import React from 'react';

// Comps
import Address from '@project-stories/ecommerce/Account/AccountAddresses/Address';
import {Button} from '@arctheme-components/elements/Button/Button';
import {Paragraph} from '@arctheme-components/elements/Paragraph/Paragraph';

const AccountAddresses = ({
  addresses,
  deleteError,
  onClickEditOrAdd,
  onClickRemove,
  locales,
  defaultCountry
}: {
  addresses: any;
  deleteError: string;
  onClickEditOrAdd: (event: React.ClickEvent<HTMLAnchorElement>, address: any) => void;
  onClickRemove: (event: React.ClickEvent<HTMLAnchorElement>, addressId: number) => void;
  locales: any;
  defaultCountry?: string;
}) => {
  if (!addresses) return null;

  const sortedAddresses = addresses.sort((a, b) => {
    if (a.default && !b.default) {
      return -1;
    } else if (!a.default && b.default) {
      return 1;
    } else {
      return 0;
    }
  });

  return (
    <div className={`account-addresses ${!addresses.length ? 'flex flex-col items-center' : ''}`}>
      {addresses.length ? (
          <div className='flex flex-row gap-[48px]'>
            {sortedAddresses.map((address, index) => (
              <Address
                key={address.id}
                address={address}
                isDefault={address.default}
                index={index}
                onClickEdit={onClickEditOrAdd}
                onClickRemove={onClickRemove}
                locales={locales}
              />
            ))}
          </div>
      ) : (
        <Paragraph
          type='b2 text-center'
          text={`<p>${locales.empty}</p>`}
        />
      )}

      {deleteError && (
        <Paragraph
          type='errors mt-4'
          text={deleteError}
        />
      )}

        <div className='flex flex-col space-y-4 pt-[20px]'>
          <Button
            type='button'
            label={locales.addNew}
            classes={`btn-secondary mt-6`}
            onClick={(e) =>
              onClickEditOrAdd(e, {
                firstName: '',
                lastName: '',
                company: '',
                address1: '',
                address2: '',
                city: '',
                province: '',
                zip: '',
                country: defaultCountry,
                id: null
              })
            }
          />
        </div>
    </div>
  );
};

export default AccountAddresses;
